module.exports = __webpack_public_path__ + "static/media/BB_greet.186a2db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_greet.png
// module id = 1272
// module chunks = 0